import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl } from "../Univ";

function AddCategory() {
  const [categories, setCategories] = useState([]);
  const [parent, setParent] = useState("");
  const [formData, setFormData] = useState({ name: "", description: "" });
  const [isLoading, setIsLoading] = useState(false);

  // ---------------- FETCH CATEGORIES ----------------
  const fetchCategories = () => {
    setIsLoading(true);
    axios
      .get(baseUrl + "categories/")
      .then((res) => {
        setCategories(res.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  useEffect(() => fetchCategories(), []);

  // ---------------- SUBMIT CATEGORY ----------------
  const submitHandler = (e) => {
    e.preventDefault();

    axios
      .post(baseUrl + "categories/", {
        name: formData.name,
        description: formData.description,
        parent: parent || null,
      })
      .then(() => {
        Swal.fire("Success", "Category Added", "success");
        setFormData({ name: "", description: "" });
        setParent("");
        fetchCategories();
      })
      .catch(() => Swal.fire("Error", "Failed to add category", "error"));
  };

  // ---------------- DELETE CATEGORY ----------------
  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm Delete?",
      icon: "warning",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + `categories/delete/${id}/`).then(() => {
          Swal.fire("Deleted!", "Category removed", "success");
          fetchCategories();
        });
      }
    });
  };

  // ---------------- BUILD BREADCRUMB ----------------
  const buildPath = (cat) => {
    let path = [cat.name];
    let p = categories.find((c) => c.id === cat.parent);
    while (p) {
      path.unshift(p.name);
      p = categories.find((c) => c.id === p.parent);
    }
    return path.join(" › ");
  };

  // ---------------- DATAGRID COLUMNS ----------------
  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "name", headerName: "Name", width: 200 },
    {
      field: "breadcrumb",
      headerName: "Full Path",
      width: 400,
      valueGetter: (params) => (params?.row ? buildPath(params.row) : ""),
    },
    { field: "description", headerName: "Description", width: 300 },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      renderCell: (params) => (
        <button
          className="btn btn-danger btn-sm"
          onClick={() => handleDelete(params.row.id)}
        >
          Delete
        </button>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      {/* ADD CATEGORY FORM */}
      <div className="card mb-4">
        <h4 className="card-header text-center">Add Category / Subcategory</h4>
        <div className="card-body">
          <form onSubmit={submitHandler}>
            <select
              className="form-control mb-2"
              value={parent}
              onChange={(e) => setParent(e.target.value)}
            >
              <option value="">-- No Parent (Top Level) --</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {buildPath(cat)}
                </option>
              ))}
            </select>

            <input
              name="name"
              className="form-control mb-2"
              placeholder="Category Name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              required
            />

            <textarea
              name="description"
              className="form-control mb-3"
              placeholder="Description"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
            />

            <button className="btn btn-success w-100">Save Category</button>
          </form>
        </div>
      </div>

      {/* DATAGRID */}
      <div style={{ width: "100%" }}>
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
          rows={categories}
          columns={columns}
          loading={isLoading}
          autoHeight
          pageSize={10}
          components={{ Toolbar: GridToolbar }}
        />
      </div>
    </div>
  );
}

export default AddCategory;
